import './assets/styles/index.css';

import { ThemeProvider } from '@mui/material/styles';
import { Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from 'react-router/dom';

import theme from './assets/styles/theme';
import Loader from './components/Loader';
import { router } from './routing';

function App() {
  return (
    <Suspense fallback={<Loader />}>
      <HelmetProvider>
        <ThemeProvider theme={theme}>
          <RouterProvider router={router} />
        </ThemeProvider>
      </HelmetProvider>
    </Suspense>
  );
}

export default App;
